export default {
      id: "check-circle-usage",
      viewBox: "0 0 15 15",
      url: __webpack_public_path__ + "sprite.svg#check-circle",
      toString: function () {
        return this.url;
      }
    }